import { PaintBrushIcon } from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';
import { Link } from 'react-router';
import { useAppointmentProposals } from '../../../data-access/appointmentProposals';
import ROUTE_PATHS from '../../../routes/paths';

const EditPresentationButton: React.FC = () => {
  const { currentProposal } = useAppointmentProposals();

  if (!currentProposal) {
    return null;
  }

  return (
    <Button
      component={Link}
      color={'softGold'}
      startIcon={<PaintBrushIcon />}
      to={ROUTE_PATHS.APPOINTMENT_PATH({
        appointmentId: currentProposal.appointmentId,
        appointmentProposalId: currentProposal.appointmentProposalId,
        path: 'edit-presentation',
      })}
    >
      Theme editor
    </Button>
  );
};

export default EditPresentationButton;
